import { theme } from 'lib/style';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

const Wrapper = styled.div`
  width: 140px;
  padding: 8px 12px;
  color: ${theme.palette.gray100};
`;

export const CRMPopup = () => {
  const { t } = useTranslation();
  return <Wrapper>{t('Script Assist')} CRM</Wrapper>;
};
